import { render, staticRenderFns } from "./Aboutus-K520c.vue?vue&type=template&id=b7fbf742&scoped=true&"
import script from "./Aboutus-K520c.vue?vue&type=script&lang=js&"
export * from "./Aboutus-K520c.vue?vue&type=script&lang=js&"
import style0 from "./Aboutus-K520c.vue?vue&type=style&index=0&id=b7fbf742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fbf742",
  null
  
)

export default component.exports